import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CheckoutPersonalDetailsFormValue } from '@oren/util-foundation';
import { CheckoutState, OREN_CHECKOUT_FEATURE_KEY } from './checkout.reducer';

export const getCheckoutState = createFeatureSelector<CheckoutState>(
  OREN_CHECKOUT_FEATURE_KEY
);

export const getTermsAndConditionsAccepted = createSelector(
  getCheckoutState,
  (state: CheckoutState): boolean => state.termsAndConditionsAccepted
);

export const getEmailAddress = createSelector(
  getCheckoutState,
  (state: CheckoutState): string | undefined => state.email
);

export const getCheckoutPersonalDetailsFormValue = createSelector(
  getCheckoutState,
  (state: CheckoutState): CheckoutPersonalDetailsFormValue => ({
    email: state.email,
    termsAndConditionsAccepted: state.termsAndConditionsAccepted,
  })
);
